import { render, staticRenderFns } from "./EmergencyIcon.vue?vue&type=template&id=33d0dc9e&scoped=true"
import script from "./EmergencyIcon.vue?vue&type=script&lang=js"
export * from "./EmergencyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d0dc9e",
  null
  
)

export default component.exports